<template>
    <ui-Airboard :panel="'login'" :openTab="false" :idView="`componet_${_uid}`" :loading="loading">
        <template v-slot:body>
            <inline-svg class="logo" :src="getImage('mysair-logo.svg')"></inline-svg>
            <div class="welcome">{{ $dicc.register.title }}</div>
            <FormMixinInput
                type="select"
                :label="$dicc.user.lang"
                property="lang"
                :options="$fns.orderObjectByValue($config.AVAILABLE_LANGS)"
            ></FormMixinInput>
            <FormMixinInput type="text" :label="$dicc.user.name" property="name"></FormMixinInput>
            <FormMixinInput type="tel" :label="$dicc.user.phone" property="phone"></FormMixinInput>
            <FormMixinInput type="email" :label="$dicc.user.email" property="email"></FormMixinInput>
            <FormMixinInput type="password" :label="$dicc.user.pass" property="password"></FormMixinInput>
            <FormMixinInput
                type="password"
                :label="$dicc.register.passConfirmation"
                property="password_confirmation"
                @keyup.enter="doRegister"
            ></FormMixinInput>
            <FormMixinInput
                class="disabled"
                type="checkbox"
                :label="$dicc.register.gdprTerms"
                property="gdpr_terms"
                @click="showConfigInfoPanel = true"
                disabled
            ></FormMixinInput>
            <FormMixinInput
                type="checkbox"
                :label="$dicc.register.gdprNotifications"
                property="gdpr_notifications"
            ></FormMixinInput>
            <a class="btn btn--simple my-3" @click.stop.prevent="doRegister" href>{{ $dicc.confirm }}</a>
            <hr />
            <router-link :to="{ name: 'Login' }" class="link my-2">{{ $dicc.register.loginAction }}</router-link>
        </template>

        <template v-slot:panels>
            <ConfigInfoPanel :show.sync="showConfigInfoPanel"></ConfigInfoPanel>
        </template>
    </ui-Airboard>
</template>

<script>
    import { FormMixin } from '../mixins/FormMixin';
    import ConfigInfoPanel from '../view_panels/ConfigInfoPanel';

    export default {
        name: 'Register',
        mixins: [FormMixin],
        components: {
            ConfigInfoPanel,
        },
        data: function() {
            return {
                loading: 0,
                showConfigInfoPanel: false,
            };
        },
        mounted() {
            this.model.lang = this.$lang;
        },
        methods: {
            init() {
                this.$set(this, 'model', {
                    name: null,
                    email: null,
                    password: null,
                    password_confirmation: null,
                    phone: null,
                    gdpr_terms: true,
                    gdpr_notifications: false,
                    gdpr_emailing: true, //TODO: quitar
                    lang: null,
                });
            },

            doRegister: function() {
                this.loading++;
                this.resetErrors();

                this.$api.register(
                    {
                        ...this.model,
                        redirect_uri: this.$router.getFullRoute({ name: 'Verify' }),
                    },
                    (data) => {
                        this.$session.login(data.entity);
                        this.$router.push({ name: 'Dashboard' });
                    },
                    (error) => this.showError(error, `#componet_${this._uid}`),
                    () => this.loading--
                );
            },
        },
        watch: {
            'model.lang': {
                immediate: true,
                handler(val) {
                    this.$changeLanguage(val);
                },
            },
        },
    };
</script>
